import * as React from 'react'
import cx from 'classnames'

import Styles from './InfoTooltip.module.scss'
import { FloatingPopover } from 'components/FloatingPopover/FloatingPopover'
import { Placement } from '@floating-ui/core'

interface Props {
  label?: string
  description: string | React.ReactNode
  icon?: React.ReactNode
  children: React.ReactElement
  placement: Placement
  className?: string
}

export const InfoTooltip = ({ label, description, icon, children, placement, className }: Props) => {
  const content = (
    <div className={cx(Styles.tooltipContent, className)}>
      {icon && <div>{icon}</div>}
      <div>
        {label && <div className={Styles.tooltipHeader}>{label}</div>}
        <div>{description}</div>
      </div>
    </div>
  )

  return (
    <FloatingPopover placement={placement} content={content}>
      {children}
    </FloatingPopover>
  )
}
